"use strict";

exports.__esModule = true;
exports.filterPropsWithGroup = void 0;

const filterPropsWithGroup = (props, config) => {
  var _config$bordered, _config$borderWeight, _config$ghost, _config$ripple, _config$flat, _config$animated, _config$rounded, _config$light, _config$size, _config$color, _config$disabled;

  if (!config.isButtonGroup) return props;
  return { ...props,
    auto: true,
    shadow: false,
    bordered: (_config$bordered = config.bordered) != null ? _config$bordered : props.bordered,
    borderWeight: (_config$borderWeight = config.borderWeight) != null ? _config$borderWeight : props.borderWeight,
    ghost: (_config$ghost = config.ghost) != null ? _config$ghost : props.ghost,
    ripple: (_config$ripple = config.ripple) != null ? _config$ripple : props.ripple,
    flat: (_config$flat = config.flat) != null ? _config$flat : props.flat,
    animated: (_config$animated = config.animated) != null ? _config$animated : props.animated,
    rounded: (_config$rounded = config.rounded) != null ? _config$rounded : props.rounded,
    light: (_config$light = config.light) != null ? _config$light : props.light,
    size: (_config$size = config.size) != null ? _config$size : props.size,
    color: (_config$color = config.color) != null ? _config$color : props.color,
    disabled: (_config$disabled = config.disabled) != null ? _config$disabled : props.disabled
  };
};

exports.filterPropsWithGroup = filterPropsWithGroup;